const styles = {
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};

export default styles;
